/**
 * Parses a market cap string that may include M/B suffixes into a numeric value in millions.
 * Examples: "500M" -> 500, "1.5B" -> 1500, "2000" -> 2000
 * Returns null for empty or invalid input.
 */
export function parseMarketCapValue(input: string): number | null {
  if (!input?.trim()) {
    return null;
  }

  const trimmed = input.trim().toUpperCase();
  const match = new RegExp(/^(\d+\.?\d*)\s*([MB])?$/).exec(trimmed);

  if (!match) {
    return null;
  }

  const numericValue = Number.parseFloat(match[1]);

  if (Number.isNaN(numericValue)) {
    return null;
  }

  const suffix = match[2];

  if (suffix === 'B') {
    return numericValue * 1000;
  }
  return numericValue;
}
